// extracted by mini-css-extract-plugin
export default {"root":"PunchupPrintTicketButtons_root__9crw+","smallButton":"PunchupPrintTicketButtons_smallButton__fKftV punchupButtonOutline"};